import React from 'react';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import MUITabs from '@mui/material/Tabs';

import { useOverviewAdData } from '../../hook';

export const Tabs = ({
    activeFilter,
    handleChangeActiveFilter,
    generatedConfigs,
    showWhileLoading = false,
}) => {
    const { endingSoon, isLoading, upcoming, recentlyEnded } = useOverviewAdData();

    const handleTabValue = (event, newTabValue) => {
        handleChangeActiveFilter(newTabValue, generatedConfigs);
    };

    return (
        (showWhileLoading || !isLoading) && (
            <Box mb={3} borderBottom="1px solid lightGrey">
                <MUITabs
                    value={activeFilter}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleTabValue}
                >
                    <Tab label={`(${endingSoon.length}) Currently Live`} value="live" />
                    <Tab label={`(${recentlyEnded.length}) Ended Last 7 Days`} value="ended" />
                    <Tab label={`(${upcoming.length}) Starting Next 7 Days`} value="upcoming" />
                </MUITabs>
            </Box>
        )
    );
};
